/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Cta_My_AccountInputs */

const es_nav_cta_my_account = /** @type {(inputs: Nav_Cta_My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi cuenta`)
};

const gl_nav_cta_my_account = /** @type {(inputs: Nav_Cta_My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A miña conta`)
};

const en_nav_cta_my_account = /** @type {(inputs: Nav_Cta_My_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My account`)
};

/**
* | output |
* | --- |
* | "My account" |
*
* @param {Nav_Cta_My_AccountInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_cta_my_account = /** @type {((inputs?: Nav_Cta_My_AccountInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Cta_My_AccountInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_cta_my_account(inputs)
	if (locale === "en") return en_nav_cta_my_account(inputs)
	return es_nav_cta_my_account(inputs)
});